'use client';

import { FC } from 'react';

import { FlagExperiment } from '@/data/FlagsApi/FlagsApi.type';
import { useABTestEvent } from '@/general/components/ABTest/useABTestEvent';
import { Button } from 'src/general/components/Button/Button';
import { Divider } from 'src/general/components/Divider/Divider';
import { pushToDataLayer } from 'src/utils/pushToDataLayer';

export const HeroCTAButtons: FC<{ abTestExperiment: FlagExperiment | null }> = ({ abTestExperiment }) => {
  const { triggerEvent: triggerEventFindMyNextCar } = useABTestEvent(abTestExperiment, 'conversion_0', {
    enabled: false,
  });
  const { triggerEvent: triggerEventSellMyCar } = useABTestEvent(abTestExperiment, 'conversion_1', {
    enabled: false,
  });

  return (
    <div className="flex gap-2 sm:flex-col sm:gap-1">
      <Button
        data-testid="hero-cta-find-car"
        href="/used-cars"
        fullWidth
        variant="accent"
        onClick={() => {
          triggerEventFindMyNextCar();
          pushToDataLayer({
            event: 'search_click_browse_all_cars',
          });
        }}
      >
        Find my next car
      </Button>
      <div className="hidden sm:block">
        <Divider>or</Divider>
      </div>
      <Button
        data-testid="hero-cta-sell-car"
        href="/sell-or-trade-in-my-car"
        fullWidth
        variant="secondary"
        onClick={() => {
          triggerEventSellMyCar();
          pushToDataLayer({
            event: 'homepage_click_sell_my_car',
          });
        }}
      >
        Sell my car
      </Button>
    </div>
  );
};
